export enum SaveInvoiceSource {
    OnSave= 'on-save',
    OnSubmit= 'on-submit',
    OnCreateTimesheet= 'on-create-timesheet'
}
